import React from "react";
//#region types
import { SupplierSimpleTodoCardProps } from "models/propTypes/supplierPropTypes";
import { WintUtilsWebApi } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { TodoConstants } from "utils/constants";
//#endregion
//#region components
import {
  EntityNavigationCard,
  EntityNavigationCardContainer,
  EntityNavigationCardContent,
  Skeletons,
} from "components/common";
import { AllCompleteSimpleTodoCard } from "components/todos/simpleTodoCards";
import { useSupplierService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import { useNavigate, useLocation } from "react-router-dom";

const SupplierSimpleTodoCard: React.FC<SupplierSimpleTodoCardProps> = (props) => {
  const supplierService = useSupplierService();
  const { supplierId } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const getTodos = React.useCallback((filter?: WintUtilsWebApi.Filter) => {
    return supplierService.getTodos(supplierId, filter);
  }, []);

  const onButtonClick = async (id: number) => {
    navigate(UrlHelper.formatPath(`/IncomingInvoice/${id}`), {
      state: { background: location },
    });
  };

  const render = (
    total: number,
    numPerPage: number,
    onCurrentIndexUpdate: (index: number, pageNumber: number) => void,
    markAsDone: (id: number) => void,
    currentItem: any,
    loading: boolean
  ) =>
    loading ? (
      <Skeletons.WidgetSkeleton />
    ) : (
      <EntityNavigationCard
        displayType={total ? StyleEnums.DisplayType.Info : StyleEnums.DisplayType.Success}
        headerText={total ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Todo) : ""}
        total={total}
        onCurrentIndexUpdate={onCurrentIndexUpdate}
        navigationText={""}
      >
        {total ? (
          <EntityNavigationCardContent
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TodoType_0) ?? ""}
            description={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.TodoDescription, "", {
              amount: LocalizationHelperInstance.getFormattedCurrency(currentItem?.amount ?? 0, currentItem?.currency),
            })}
            buttonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ViewInvoice) ?? ""}
            showButton
            displayType={StyleEnums.DisplayType.Info}
            onClick={() => onButtonClick(currentItem.id)}
          />
        ) : (
          <AllCompleteSimpleTodoCard />
        )}
      </EntityNavigationCard>
    );

  return (
    <EntityNavigationCardContainer
      render={render}
      filter={getTodos}
      numPerPage={TodoConstants.TodosPerPage}
    ></EntityNavigationCardContainer>
  );
};
export default SupplierSimpleTodoCard;
